/*
 * To apply custom theme to react-json-view objects, we need to follow thier base 16 theme styling guidelines
 * indicated here - https://github.com/chriskempson/base16/blob/master/styling.md and implemented below.
 */

export const darkjsonViewerTheme = {
  base00: '#122531',
  base01: '#122531',
  base02: '#122531',
  base03: '#122531',
  base04: 'rgba(255,255,255,0.35)',
  base05: '#122531',
  base06: '#122531',
  base07: 'rgba(255,255,255,0.85)',
  base08: '#122531',
  base09: '#ffbc00',
  base0A: '#122531',
  base0B: 'rgba(255,255,255,0.85)',
  base0C: 'rgba(255,255,255,0.85)',
  base0D: '#00b0f5',
  base0E: '#dcc6e0',
  base0F: 'rgba(255,255,255,0.85)',
};

export const lightjsonViewerTheme = {
  base00: '#f0f1f3',
  base01: '#f0f1f3',
  base02: '#f0f1f3',
  base03: '#f0f1f3',
  base04: 'rgba(0,0,0,0.55)',
  base05: '#f0f1f3',
  base06: '#f0f1f3',
  base07: 'rgba(0,0,0,0.85)',
  base08: '#f0f1f3',
  base09: '#a000bc',
  base0A: '#f0f1f3',
  base0B: 'rgba(0,0,0,0.85)',
  base0C: 'rgba(0,0,0,0.85)',
  base0D: '#00b0f5',
  base0E: '#7928a1',
  base0F: 'rgba(0,0,0,0.85)',
};
